import { ProductTileForCarousel } from "@faire/deprecated-retailer-visitor-shared/components/Carousel/ProductTileForCarousel";
import { ILeanProductTileWithBrand } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { IProductLinkProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/generateProductLinkPropsForLoggedOutRetailer";
import { isAdmin } from "@faire/deprecated-retailer-visitor-shared/lib/isAdmin";
import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { brandPage } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { ProductPagePaths } from "@faire/deprecated-retailer-visitor-shared/paths/ProductPage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { getLocation } from "@faire/web/common/globals/getLocation";
import { moneyOrZero } from "@faire/web/common/money";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";
import { isPrerender } from "@faire/web/common/user-agent/isPrerender";
import { Location } from "history";

export const buildTileFromLeanProductTile = (
  productTile: ILeanProductTile | undefined
): ProductTileForCarousel.IProps | undefined => {
  if (
    !productTile?.product?.name ||
    !productTile?.product?.token ||
    !productTile?.best_image
  ) {
    return undefined;
  }

  return {
    bestImage: productTile.best_image,
    images: productTile.images,
    name: productTile.product.name,
    token: productTile.product.token,
    wholesalePrice: moneyOrZero(productTile.min_option_wholesale_price),
    retailPrice: moneyOrZero(productTile.min_option_retail_price),
    promoPrice: productTile.min_option_wholesale_promo_price,
    to: ProductPagePaths.index(productTile.product.token),
    isHighlightedProductForPromotionalEvent:
      productTile.is_highlighted_product_for_promotional_event,
    badges: productTile.badge_list?.badges.filter(
      (badge) => badge.display_to_user
    ),
    brandToken: productTile.product.brand_token,
  };
};

export const handleGenerateProductLinkProps =
  (
    productTile: ILeanProductTile | ILeanProductTileWithBrand | undefined,
    location: Location,
    user: IUser | undefined,
    queryParamOverrides?: ProductPagePaths.index.IQueries
  ) =>
  (): IProductLinkProps | undefined => {
    const product = productTile?.product;
    if (!product?.token) {
      return {
        productUrl: "",
      };
    }

    const { refS, refC } = getParsedParams();
    const productPageLink = ProductPagePaths.index(product.token, {
      refS,
      refC: refC ?? queryParamOverrides?.refC,
    });

    if (isLoggedInRetailer() || isAdmin(user)) {
      return { productUrl: productPageLink };
    }

    return generateProductLinkPropsForLoggedOutRetailer({
      productToken: product.token,
      brandToken: product.brand_token,
      location,
    });
  };

export const handleGenerateBrandUrl =
  (brandToken: string | undefined, productToken?: string) => () => {
    if (!brandToken) {
      return "";
    }
    if (isPrerender()) {
      return brandPage(brandToken);
    }
    const { refS, refC } = getParsedParams();
    return productToken !== undefined
      ? brandPage(brandToken, { refS, refC, refP: [productToken] })
      : brandPage(brandToken, { refS, refC });
  };

export const getParsedParams = () => {
  const rawParams = parseQueryParams(getLocation()?.search ?? "");
  return {
    refS: rawParams.getOrDefault("refS", undefined),
    refC: rawParams.getOrDefault("refC", undefined),
  };
};
